export default __webpack_public_path__ + "static/media/30.5287bdd7.png";